import PropTypes from "prop-types";
import Page401View from "src/views/errors/Page401View";
import { useSelector } from "react-redux";
import IsRole from "src/utils/IsRole";
import useAuth from "src/hooks/useAuth";
import Roles from "src/utils/Roles";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import navConfig from "src/layouts/DashboardLayout/NavBar/config";
import useEmployeeRole from "src/hooks/useEmployeeRole";

// ----------------------------------------------------------------------

RoleBasedGuard.propTypes = {
  accessibleRoles: PropTypes.array, // Example ['admin', 'leader']
  children: PropTypes.node,
};

const useCurrentRole = () => {
  // Logic here to get current user role
  const { claims } = useSelector((state) => state.authJwt);

  return claims.role;
};

const isAdminWorking = (employees) => {
  return Number(window.localStorage.getItem("UserEmployeeId")) === 0;
};

export default function RoleBasedGuard({ accessibleRoles, children }) {
  const location = useLocation();
  const userState = useSelector((state) => state.authJwt);
  const { displays } = useSelector((state) => state.displays);

  const { permissions } = useEmployeeRole();
  const currentRole = useCurrentRole();

  const { user } = useAuth();

  if (!IsRole(currentRole, accessibleRoles) && accessibleRoles.length > 0) {
    return <Page401View />;
  }

  if (
    accessibleRoles.length > 0 &&
    accessibleRoles.includes(Roles.USER_ADMIN)
  ) {
    var routes = navConfig(
      user,
      userState.user.isOnlyTpv,
      permissions,
      displays.filter((u) => u.isActive)
    ).items.filter((i) => IsRole(i.roles, userState.claims.role));

    if (!permissions || !permissions?.length) return <>{children}</>;

    if (!routes) return <>{children}</>;

    var route = routes
      ?.flatMap((r) => (r.items ? r.items : r))
      ?.find((r) => r.href === location.pathname);

    if (!route) return <>{children}</>;

    if (route.condition) return <>{children}</>;

    if (user.requestUserIdentity && !isAdminWorking()) return <Page401View />;
  }

  return <>{children}</>;
}
